import { Box } from '@factorialco/deprecated-design-system'

interface Props {
  children: JSX.Element[]
}

const Wrapper = ({ children }: Props) => (
  <Box flexDirection="row" alignItems="center">
    {children}
  </Box>
)

export default Wrapper
